import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, IQrCodeDto } from '@/dtos';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

export interface ReceiptQRCode {
  qrId?: string;
  fileUploadUrl?: string;
  employeeId?: number;
  validTo?: string;
}

const useGetReceiptQRCodeQuery = (documentId?: string) => {
  const requestBody = documentId ? { document_id: documentId } : undefined;
  const { data, isLoading, isFetching, refetch } = useQuery([API_URL.DOCUMENTS_RECEIPTS_QR_CODES, documentId], () =>
    api.post<IQrCodeDto>(API_URL.DOCUMENTS_RECEIPTS_QR_CODES, requestBody)
  );

  const formattedFileUploadUrl = useMemo(() => {
    if (!whiteLabelingConfig?.title) {
      return data?.data?.file_upload_url;
    }

    return data?.data?.file_upload_url?.replace('user', whiteLabelingConfig?.title);
  }, [data]);

  const formattedData = useMemo<ReceiptQRCode>(
    () => ({
      qrId: data?.data?.qr_id,
      fileUploadUrl: formattedFileUploadUrl,
      employeeId: data?.data?.employee_id,
      validTo: toString(data?.data?.valid_to),
    }),
    [data, formattedFileUploadUrl]
  );

  return {
    qrCodeData: formattedData,
    isLoading,
    isFetching,
    refetch,
  };
};

export default useGetReceiptQRCodeQuery;
